<div
  class="news-title-container"
  *ngIf="titolo"
  [class.notitle]="params.notitle === 'true'"
  [class.score-focus]="
    routing.isChart() && (routing.isFolio() || routing.isMarket())
  "
  [class.has-reports]="
    routing.isChart() && (routing.isQuery() || routing.isSearch())
  "
>
  <div
    class="news-title"
    *ngIf="titolo"
    [class.notitle]="params.notitle === 'true'"
    [class.score-focus]="
      routing.isChart() && (routing.isFolio() || routing.isMarket())
    "
  >
    <div class="cont">
      <div class="cont-left">
        <ng-container *ngIf="routing.isWidget() && !routing.isFolio()">
          <div class="text">
            <span class="tipo"
              ><span style="font-weight: normal"
                >{{ titolo.entity.type | nicetxt: false }}:</span
              >
              {{ titolo.entity.name | nicetxt: false }}</span
            >
            <span
              class="alert-container"
              *ngIf="
                titolo.entity.sanctions?.length > 0 &&
                auth.featureFlags.showSanctions
              "
            >
              <mat-icon
                class="sanctions-alert-icon"
                svgIcon="alert"
                matTooltip="Sanctioned Entity. Click Icon for detailed Sanction Lists Data."
                (click)="$event.stopPropagation(); openDialog(titolo.entity)"
                [class.theme-light]="theme === 'light'"
              ></mat-icon>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="routing.isMarket()">
          <div
            class="select"
            *ngIf="
              params.type &&
              (params.type === 'company' ||
                params.type === 'country' ||
                params.type === 'pne') &&
              auth.featureFlags.addEntities
            "
            [matMenuTriggerFor]="menu"
            matTooltip="Add entity to portfolio"
          >
            <mat-icon>add</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="appendItem('add')">
              Add entity to existing portfolios
            </button>
            <button mat-menu-item (click)="appendItem('create')">
              Add entity to a new portfolio
            </button>
          </mat-menu>
          <div class="text">
            <span class="tipo"
              ><span style="font-weight: normal"
                >{{ titolo.entity.type | nicetxt: false }}:</span
              >
              {{ titolo.entity.name | nicetxt: false }}</span
            >
            <span
              class="alert-container"
              *ngIf="
                titolo.entity.sanctions?.length > 0 &&
                auth.featureFlags.showSanctions
              "
            >
              <mat-icon
                class="sanctions-alert-icon"
                svgIcon="alert"
                matTooltip="Sanctioned Entity. Click Icon for detailed Sanction Lists Data."
                (click)="$event.stopPropagation(); openDialog(titolo.entity)"
                [class.theme-light]="theme === 'light'"
              ></mat-icon>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="routing.isFolio()">
          <div
            *ngIf="!routing.isWidget()"
            class="select"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu"
            matTooltip="Select entity"
          >
            <mat-icon *ngIf="!menuTrigger.menuOpen">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="menuTrigger.menuOpen">arrow_drop_up</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="select('overall')">Overall</button>
            <button
              mat-menu-item
              (click)="select(entity)"
              *ngFor="let entity of entities | orderBy: 'name'"
            >
              {{ entity.type | nicetxt: false }} :
              {{ entity.name | nicetxt: false }}
            </button>
          </mat-menu>
          <div class="text">
            <span class="tipo"
              ><span style="font-weight: normal"
                >{{ titolo.entity.type | nicetxt: false }}:</span
              >
              {{ titolo.entity.name | nicetxt: false }}</span
            >
            <span
              class="alert-container"
              *ngIf="
                titolo.entity.sanctions?.length > 0 &&
                auth.featureFlags.showSanctions
              "
            >
              <mat-icon
                class="sanctions-alert-icon"
                svgIcon="alert"
                matTooltip="Sanctioned Entity. Click Icon for detailed Sanction Lists Data."
                (click)="$event.stopPropagation(); openDialog(titolo.entity)"
                [class.theme-light]="theme === 'light'"
              ></mat-icon>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="routing.isQuery()">
          <div
            class="select"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu"
            matTooltip="Select query"
          >
            <mat-icon *ngIf="!menuTrigger.menuOpen">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="menuTrigger.menuOpen">arrow_drop_up</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="select('overall')">Overall</button>
            <button
              mat-menu-item
              (click)="select(queryItem)"
              *ngFor="let queryItem of queries | orderBy: 'name'"
            >
              {{ queryItem.name }}
            </button>
          </mat-menu>
          <div
            class="text"
            matTooltip="{{ titolo?.entity.name | nicetxt: false }}"
          >
            <span class="tipo"
              ><span style="font-weight: normal"
                >{{
                  params.id === params.groupId ? 'Collection' : 'Query'
                }}:</span
              >
              {{ auth.query?.name }}</span
            >
          </div>
        </ng-container>

        <ng-container
          *ngIf="routing.isSearch() && auth.featureFlags.addQueries"
        >
          <div
            class="select"
            [matMenuTriggerFor]="menu"
            matTooltip="Add query to collection"
          >
            <mat-icon>add</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="appendItem('add')">
              Add query to existing collections
            </button>
            <button mat-menu-item (click)="appendItem('create')">
              Add query to a new collection
            </button>
          </mat-menu>
          <div
            class="text"
            matTooltip="{{ titolo.entity.name | nicetxt: false }}"
          >
            Query: {{ titolo.entity.name | nicetxt: false }}
          </div>
        </ng-container>
      </div>

      <ng-container
        *ngIf="
          !(
            titolo &&
            routing.isChart() &&
            (routing.isFolio() || routing.isMarket())
          )
        "
      >
        <div
          *ngIf="auth.scorelabSettings.defaultFlag && showWarningFlag"
          class="cont-right"
        >
          <div
            class="info flag warning"
            [matTooltip]="getFlagTooltip('warning')?.tooltip"
          >
            <mat-icon>flag</mat-icon>
          </div>
        </div>

        <div
          *ngIf="
            auth.scorelabSettings.defaultFlag &&
            !showWarningFlag &&
            showCautionFlag
          "
          class="cont-right"
        >
          <div
            class="info flag caution"
            [matTooltip]="getFlagTooltip('caution')?.tooltip"
          >
            <mat-icon>flag</mat-icon>
          </div>
        </div>

        <div
          *ngIf="
            [
              'esg',
              'eb_sim',
              'eb_sim_risk',
              'general_risk',
              'esg_risk',
              'immediate_risk',
              'credit_risk',
              'bb',
            ].includes(this.customScore) &&
            industryBenchmarkScore !== null &&
            params.type &&
            params.type === 'company'
          "
          class="cont-right"
        >
          <div
            class="info flag bench"
            [matTooltip]="industryBenchmarkDescription"
          >
            <mat-icon
              *ngIf="industryBenchmarkScore === 0"
              svgIcon="timer-sand-full"
              class="laggard"
            ></mat-icon>
            <mat-icon
              *ngIf="industryBenchmarkScore === 1"
              svgIcon="trending-down"
              class="below"
            ></mat-icon>
            <mat-icon
              *ngIf="industryBenchmarkScore === 2"
              svgIcon="trending-up"
              class="above"
            ></mat-icon>
            <mat-icon
              *ngIf="industryBenchmarkScore === 3"
              svgIcon="medal"
              class="leader"
            ></mat-icon>
          </div>
        </div>

        <div class="cont-right">
          <div
            class="info"
            *ngIf="
              (!titolo.hasOwnProperty('score') && !(titolo.score === null)) ||
              routing.isQuery()
            "
            [style.color]="titolo.sentiment.sentiment | color"
          >
            <span>{{ titolo.sentiment.sentiment | percent }}</span>
            <div class="trendicon">
              <span class="brak">(</span>
              <span>{{
                titolo.sentiment.sentiment_delta * 100 | round | trend
              }}</span>
              <span>{{
                titolo.sentiment.sentiment_delta * 100 | round | negative
              }}</span>
              <span class="brak">)</span>
            </div>
          </div>

          <div class="info" *ngIf="titolo.score === null && !routing.isQuery()">
            <span>--</span>
          </div>
          <div
            class="info"
            *ngIf="
              titolo.hasOwnProperty('score') &&
              !['bb'].includes(this.customScore) &&
              !routing.isQuery()
            "
            [style.color]="
              auth.getScoreType() === 'pos'
                ? (titolo.score | colorScore2)
                : (titolo.score | colorScore)
            "
          >
            <span>{{ titolo.score }}</span>
          </div>
          <div
            class="info"
            *ngIf="
              titolo.hasOwnProperty('score') &&
              ['bb'].includes(this.customScore) &&
              !(['bb'].includes(this.customScore) && routing.isFolio()) &&
              !routing.isQuery()
            "
          >
            <span class="icon">
              <img
                *ngIf="titolo.trend_type === 'bear'"
                src="assets/icon/bear.svg"
              />
              <img
                *ngIf="titolo.trend_type === 'bull'"
                src="assets/icon/bull.svg"
              />
            </span>
            <span>{{ titolo.trend_value }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div
    class="news-title news-title-scores"
    *ngIf="
      titolo && routing.isChart() && (routing.isFolio() || routing.isMarket())
    "
    [class.notitle]="params.notitle === 'true'"
    [class.score-focus]="
      routing.isChart() && (routing.isFolio() || routing.isMarket())
    "
  >
    <app-report-box
      [entity]="titolo.entity"
      [folio]="folio"
      [customScore]="customScore"
    ></app-report-box>
    <app-score-box
      *ngIf="auth.scorelabSettings.defaultFlag && showWarningFlag"
      scoreType="flag"
      flagType="warning"
      [isFocused]="
        mouseOverWarningFlag ||
        auth.scorelabSettings.defaultFlag.score_type === params?.score
      "
      (scoreClick)="
        onScoreFocus(
          'warning',
          auth.scorelabSettings.defaultFlag.score_type,
          flagWarningEventsTimeframe,
          '#dd001a',
          true
        )
      "
      [scoreName]="
        getFlagTooltip('warning')?.score_threshold +
        ' ' +
        getFlagTooltip('warning')?.score_name
      "
      [scoreEventsCount]="flagWarningEventsCount"
      [scoreEventsTimeframe]="flagWarningEventsTimeframe"
      [matTooltip]="getFlagTooltip('warning')?.tooltip"
    >
    </app-score-box>
    <app-score-box
      *ngIf="
        auth.scorelabSettings.defaultFlag && !showWarningFlag && showCautionFlag
      "
      scoreType="flag"
      flagType="caution"
      [isFocused]="
        mouseOverCautionFlag ||
        auth.scorelabSettings.defaultFlag.score_type === params?.score
      "
      (scoreClick)="
        onScoreFocus(
          'caution',
          auth.scorelabSettings.defaultFlag.score_type,
          flagCautionEventsTimeframe,
          '#ff9900',
          true
        )
      "
      [scoreName]="
        getFlagTooltip('caution')?.score_threshold +
        ' ' +
        getFlagTooltip('caution')?.score_name
      "
      [scoreEventsCount]="flagCautionEventsCount"
      [scoreEventsTimeframe]="flagCautionEventsTimeframe"
      [matTooltip]="getFlagTooltip('caution')?.tooltip"
    >
    </app-score-box>

    <div
      *ngIf="
        [
          'esg',
          'eb_sim',
          'eb_sim_risk',
          'general_risk',
          'esg_risk',
          'immediate_risk',
          'credit_risk',
          'bb',
        ].includes(this.customScore) &&
        industryBenchmarkScore !== null &&
        params.type &&
        params.type === 'company'
      "
      class="score-box"
      [matTooltip]="industryBenchmarkDescription"
    >
      <div *ngIf="industryBenchmarkScore === 0" class="score-name-cont bench">
        <span class="score-icon laggard">
          <mat-icon
            *ngIf="industryBenchmarkScore === 0"
            svgIcon="timer-sand-full"
          ></mat-icon>
        </span>
        <span>{{ industryBenchmarkDescription }}</span>
      </div>
      <div *ngIf="industryBenchmarkScore === 1" class="score-name-cont bench">
        <span class="score-icon below">
          <mat-icon svgIcon="trending-down"></mat-icon>
        </span>
        <span>{{ industryBenchmarkDescription }}</span>
      </div>
      <div *ngIf="industryBenchmarkScore === 2" class="score-name-cont bench">
        <span class="score-icon above">
          <mat-icon svgIcon="trending-up"></mat-icon>
        </span>
        <span>{{ industryBenchmarkDescription }}</span>
      </div>
      <div *ngIf="industryBenchmarkScore === 3" class="score-name-cont bench">
        <span class="score-icon leader">
          <mat-icon svgIcon="medal"></mat-icon>
        </span>
        <span>{{ industryBenchmarkDescription }}</span>
      </div>
      <div class="score-info-cont">
        <span></span>
      </div>
    </div>

    <div
      #scoreBoxScoreSent
      class="score-box score-box-focus"
      *ngIf="!titolo.hasOwnProperty('score') && !(titolo.score === null)"
      [style.border-color]="titolo.sentiment.sentiment | color"
      [class.score-focused]="
        mouseOverScore || this.customScore === params?.score
      "
      (mouseover)="mouseOverScore = true"
      (mouseout)="mouseOverScore = false"
      (click)="
        onScoreFocus(
          'score',
          this.customScore,
          scoreEventsTimeframe,
          scoreBoxScoreSent,
          true
        )
      "
    >
      <ng-container *ngIf="!isLoadingEvents; else loadingEventsPlaceholder">
        <div class="score-container-cont">
          <div class="score-name-cont">
            <span
              class="score-icon"
              [style.color]="titolo.sentiment.sentiment | color"
            >
              <svg-icon src="assets/icon/o_sentiment.svg"></svg-icon>
            </span>
            <span>Sentiment</span>
            <span
              class="score-value"
              [style.color]="titolo.sentiment.sentiment | color"
              >{{ titolo.sentiment.sentiment | percent }}</span
            >
            <span
              class="score-trend"
              [style.color]="titolo.sentiment.sentiment | color"
              >({{ titolo.sentiment.sentiment_delta * 100 | round | trend
              }}{{
                titolo.sentiment.sentiment_delta * 100 | round | negative
              }})</span
            >
          </div>

          <div class="score-info-cont">
            <span *ngIf="scoreEventsCount !== null"
              >{{ scoreEventsCount | thousandSuff }} events in previous
              {{ scoreEventsTimeframe }} days</span
            >
            <span *ngIf="scoreEventsCount === null && scoreEventsTimeframe"
              >previous {{ scoreEventsTimeframe }} days</span
            >
          </div>
        </div>
      </ng-container>
      <ng-template #loadingEventsPlaceholder>
        <mat-progress-spinner
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
      </ng-template>
    </div>

    <div
      #scoreBoxScore1
      class="score-box score-box-focus"
      *ngIf="
        titolo.hasOwnProperty('score') && !['bb'].includes(this.customScore)
      "
      [style.border-color]="
        auth.getScoreType() === 'pos'
          ? (titolo.score | colorScore2)
          : (titolo.score | colorScore)
      "
      [class.score-focused]="
        mouseOverScore || this.customScore === params?.score
      "
      (mouseover)="mouseOverScore = true"
      (mouseout)="mouseOverScore = false"
      (click)="
        onScoreFocus(
          'score',
          this.customScore,
          scoreEventsTimeframe,
          scoreBoxScore1,
          true
        )
      "
    >
      <ng-container *ngIf="!isLoadingEvents; else loadingEventsPlaceholder">
        <div class="score-container-cont">
          <div class="score-name-cont">
            <span
              class="score-icon"
              *ngIf="
                this.customScore &&
                !['eb_sim', 'eb_sim_risk'].includes(this.customScore)
              "
              [style.color]="
                auth.getScoreType() === 'pos'
                  ? (titolo.score | colorScore2)
                  : (titolo.score | colorScore)
              "
            >
              <svg-icon
                src="{{ 'assets/icon/o_' + this.customScore + '.svg' }}"
              ></svg-icon>
            </span>
            <span>{{ auth.getScoresInfo(this.customScore)['name'] }}</span>
            <span
              class="score-value"
              [style.color]="
                auth.getScoreType() === 'pos'
                  ? (titolo.score | colorScore2)
                  : (titolo.score | colorScore)
              "
              >{{ titolo.score }}</span
            >
          </div>

          <div class="score-info-cont">
            <span *ngIf="scoreEventsCount !== null"
              >{{ scoreEventsCount | thousandSuff }} events in previous
              {{ scoreEventsTimeframe }} days</span
            >
            <span *ngIf="scoreEventsCount === null && scoreEventsTimeframe"
              >previous {{ scoreEventsTimeframe }} days</span
            >
          </div>
        </div>
      </ng-container>
      <ng-template #loadingEventsPlaceholder>
        <mat-progress-spinner
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
      </ng-template>
    </div>

    <div
      #scoreBoxScore2
      class="score-box score-box-focus"
      *ngIf="
        titolo.hasOwnProperty('score') &&
        ['bb'].includes(this.customScore) &&
        !routing.isQuery()
      "
      [style.border-color]="
        titolo.trend_type === 'bear' ? '#dd001a' : '#1e816c'
      "
      [class.score-focused]="
        mouseOverScore || this.customScore === params?.score
      "
      (mouseover)="mouseOverScore = true"
      (mouseout)="mouseOverScore = false"
      (click)="
        onScoreFocus(
          'score',
          this.customScore,
          scoreEventsTimeframe,
          scoreBoxScore2,
          true
        )
      "
    >
      <ng-container *ngIf="!isLoadingEvents; else loadingEventsPlaceholder">
        <div class="score-container-cont">
          <div class="score-name-cont">
            <span
              class="score-icon bb-icon"
              *ngIf="this.customScore"
              [style.color]="
                titolo.trend_type === 'bear' ? '#dd001a' : '#1e816c'
              "
            >
              <img
                *ngIf="titolo.trend_type === 'bear'"
                src="assets/icon/bear.svg"
              />
              <img
                *ngIf="titolo.trend_type === 'bull'"
                src="assets/icon/bull.svg"
              />
            </span>
            <span>{{ auth.getScoresInfo(this.customScore)['name'] }}</span>
            <span
              class="score-value"
              [style.color]="
                titolo.trend_type === 'bear' ? '#dd001a' : '#1e816c'
              "
              >{{ titolo.trend_value }}</span
            >
          </div>
          <div class="score-info-cont">
            <span *ngIf="scoreEventsCount !== null"
              >{{ scoreEventsCount | thousandSuff }} events in previous
              {{ scoreEventsTimeframe }} days</span
            >
            <span *ngIf="scoreEventsCount === null && scoreEventsTimeframe"
              >previous {{ scoreEventsTimeframe }} days</span
            >
          </div>
        </div>
      </ng-container>
      <ng-template #loadingEventsPlaceholder>
        <mat-progress-spinner
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
      </ng-template>
    </div>

    <ng-container *ngIf="alertScoreType === 'sentiment'">
      <app-score-box
        *ngIf="alertScoreType"
        [isFocused]="mouseOverAlert || alertScoreType === params?.score"
        scoreType="sentiment"
        [scoreData]="{
          sentiment: titolo.sentiment.sentiment,
          sentiment_delta: titolo.sentiment.sentiment_delta,
        }"
        scoreName="Sentiment"
        [scoreColor]="titolo.sentiment.sentiment | color"
        [scoreEventsCount]="alertEventsCount"
        [scoreEventsTimeframe]="alertEventsTimeframe"
        (scoreClick)="
          onScoreFocus(
            'alert',
            alertScoreType,
            alertEventsTimeframe,
            getSentimentColor(titolo.sentiment.sentiment),
            true
          )
        "
      >
      </app-score-box>
    </ng-container>

    <ng-container
      *ngIf="alertScoreType && !['sentiment', 'bb'].includes(alertScoreType)"
    >
      <app-score-box
        [isFocused]="mouseOverAlert || alertScoreType === params?.score"
        scoreType="score"
        [scoreValue]="alertScoreValue"
        [scoreName]="auth.getScoresInfo(alertScoreType)['name']"
        [scoreColor]="
          auth.getScoreType(alertScoreType) === 'pos'
            ? (alertScoreValue | colorScore2)
            : (alertScoreValue | colorScore)
        "
        [iconSrc]="'assets/icon/o_' + alertScoreType + '.svg'"
        [scoreEventsCount]="alertEventsCount"
        [scoreEventsTimeframe]="alertEventsTimeframe"
        (scoreClick)="
          onScoreFocus(
            'alert',
            alertScoreType,
            alertEventsTimeframe,
            getTypedScoreColor(alertScoreValue, alertScoreType),
            true
          )
        "
      >
      </app-score-box>
    </ng-container>

    <ng-container *ngIf="alertScoreType && ['bb'].includes(alertScoreType)">
      <app-score-box
        *ngIf="alertScoreValue"
        [isFocused]="mouseOverAlert || alertScoreType === params?.score"
        scoreType="bb"
        [scoreData]="{
          trend_type: alertScoreValue.trend_type,
          trend_value: alertScoreValue.trend_value,
        }"
        [scoreName]="auth.getScoresInfo(alertScoreType)['name']"
        [scoreColor]="
          alertScoreValue.trend_type === 'bear' ? '#dd001a' : '#1e816c'
        "
        [scoreEventsCount]="alertEventsCount"
        [scoreEventsTimeframe]="alertEventsTimeframe"
        (scoreClick)="
          onScoreFocus(
            'score',
            alertScoreType,
            alertEventsTimeframe,
            alertScoreValue.trend_type === 'bear' ? '#dd001a' : '#1e816c',
            true
          )
        "
      >
      </app-score-box>
    </ng-container>
  </div>
</div>
